import { SET_LAUNCHYDARKLY_FLAGS } from './types';

export function setLaunchDarklyFlags(flags) {
  return {
    type: SET_LAUNCHYDARKLY_FLAGS,
    payload: flags
  };
}
